const RegisterPage = () => {

    return (
        <>
            <h1 className="text-center">Реєстрація на сайті</h1>

        </>
    )
}

export default RegisterPage;

